import { Spin } from "antd";
import { colors } from "theme/theme";
import styled from "styled-components";

interface LoaderProps {
    isFullScreen?: boolean;
    text: string;
}

const LoaderWrapper = styled.div<{ isFullScreen: boolean | undefined }>`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: ${props => props.isFullScreen ? "calc(100vh)" : "initial"};
    
    .ant-spin-text {
        color: ${colors.text};
        font-size: 1.6rem;
        margin-top: 20px;
    }

    .ant-spin-dot-item {
        background-color: ${colors.secondary};
    }
`;

function Loader ({ isFullScreen, text } : LoaderProps) {
    return <LoaderWrapper isFullScreen={isFullScreen}>
      <Spin tip={text} size="large" />
    </LoaderWrapper>;
}

export default Loader;